import Typography from "@mui/material/Typography";
import FormField from "shared/form/FormField";
import BoxContent from "shared/ui/BoxContent";

const TestDuration = ({ errors, itemsNumber, handleSelectChange, selectedCategoriesCount }: any) => {

    return (
        <>
            <Typography variant="h3" mb={3} mt={3}>
                Alege numărul de itemi
            </Typography>
            <Typography variant="body1" mb={3}>
                Pentru generarea testului și scorarea optimă a acestuia, fiecare capitol de materie selectat va include <b>minimum 10 itemi</b>.
            </Typography>
            <BoxContent>
                <FormField
                    name="test_duration"
                    type="controlled-select"
                    label="Alege numărul de itemi"
                    value={itemsNumber}
                    defaultValue={"default"}
                    onChange={handleSelectChange}
                    options={[
                        {
                            label: "10 (30 minute)",
                            value: 10,
                        },
                        {
                            label: "15 (45 minute)",
                            value: 15,
                        },
                        {
                            label: "20 (60 minute)",
                            value: 20,
                        },
                        {
                            label: "25 (75 minute)",
                            value: 25,
                        },
                        {
                            label: "30 (90 minute)",
                            value: 30,
                        },
                        {
                            label: "35 (105 minute)",
                            value: 35,
                        },
                        {
                            label: "40 (120 minute)",
                            value: 40,
                        }
                    ].map((option) => ({
                        ...option,
                        disabled: selectedCategoriesCount ? option.value < selectedCategoriesCount * 10 : false,
                    }))}
                    errorMessage={errors.test_duration?.message}
                />
            </BoxContent>
        </>
    );
};

export default TestDuration;
